import { drilldownData, ModuleFields } from "~/Utils/drilldownData";

const mapFields = (data: ModuleFields[]) => {
  return (
    data.map(({ fieldName, placeholder, name, formType, validation, className, options, loadOptions, imageDimension }) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      options: options,
      loadOptions: loadOptions,
      imageDimension: imageDimension
    }))
  )
}

export const fields: any = {
  storeLocations: mapFields(
    drilldownData["storeLocations"]
  ),

  airport: drilldownData["airport"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
  level: drilldownData["level"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
  outlet: drilldownData["outlet"].map(({ fieldName, placeholder, name, formType, validation, className, usedFileType, imageDimension }: ModuleFields) => ({
    name: name,
    type: formType,
    label: fieldName,
    placeholder: placeholder,
    validation: validation,
    className: className,
    usedFileType: usedFileType,
    imageDimension: imageDimension
  })),
};
